const oldSystemLink = 'https://option.syntecclub.com/option/default.aspx';

export default {
  oldSystemLink,
};
